/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-08-09 09:58:42
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-15 16:02:07
 */import React from 'react'


export default class Iframe extends React.Component {


    componentDidMount() {
        console.log('Iframedd', this.props.url)
    }


    render() {
        let props = this.props.location
        // let path=props.pathname.substring(8)
        return <>
            {/* <Header4></Header4> */}

            <iframe
                title={"344343"}
                style={this.props.blank ? { width: '100%', height: '100vh', position: 'absolute', zIndex: 0 } : { width: '100%', height: 'calc(100vh - 64px)', position: 'absolute', zIndex: 0 }}
                // sandbox="allow-scripts allow-forms allow-same-origin"
                // sandbox="allow-downloads allow-top-navigation allow-forms allow-scripts allow-popups allow-same-origin"
                // sandbox="allow-same-origin"
                // sandbox="allow-top-navigation"
                // src={`${this.props.url}?token=${getCookie("token")}`}>
                src={`${this.props.url}`}>
            </iframe></>
    }
}